import React from "react";
import "../views/chatpage.css";
import { useParams } from "react-router-dom";
import ChatComponent from "./ChatComponent";

export default function ChatPage() {
    const { id } = useParams();

    return (
        <div className="main-page-chat">
            <ChatComponent _id={id} />
        </div>
    );
}
